import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const ObstetricsGynaecologyIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M80.3569 40C80.3569 61.8153 62.6722 79.5 40.8569 79.5C19.0417 79.5 1.35693 61.8153 1.35693 40C1.35693 18.1848 19.0417 0.5 40.8569 0.5C62.6722 0.5 80.3569 18.1848 80.3569 40Z'
      />
      <g clipPath='url(#clip0_414_8465)'>
        <path
          d='M50.8634 44.7487C48.9834 43.975 46.9084 43.9712 45.0203 44.7525C44.864 44.8175 44.7072 44.8744 44.5497 44.9344C40.7259 49.5519 34.9509 52.5 28.5003 52.5H27.5034C30.8728 57.5206 36.5978 60.8337 43.0834 60.8337C51.7434 60.8337 59.0472 54.2737 61.1928 45.3944C57.784 46.3344 54.1822 46.1231 50.8634 44.7487Z'
          fill='#E0F2F7'
        />
        <path
          d='M58.4647 45.9005C56.2822 53.1224 50.214 58.3337 43.0834 58.3337C38.2034 58.3337 33.6303 56.1374 30.5497 52.3987C29.8753 52.4643 29.1915 52.4999 28.5003 52.4999H27.5034C30.8728 57.5205 36.5978 60.8337 43.0834 60.8337C51.7434 60.8337 59.0472 54.2737 61.1928 45.3943C60.2934 45.6418 59.3822 45.8143 58.4647 45.9005Z'
          fill='#B6E2EB'
        />
        <path
          d='M52.458 40.8988C55.4668 42.1488 58.6961 42.055 61.4849 40.8988C61.5943 40.8538 61.7049 40.8144 61.8149 40.7719C61.8236 40.5156 61.8324 40.2594 61.8324 40C61.8324 33.225 58.0161 27.5 53.4993 27.5C51.9755 27.5 50.5636 27.9419 49.3324 28.6594V31.6669C49.3324 34.6325 48.7055 37.4531 47.583 40.0094C49.2061 39.9581 50.863 40.2381 52.458 40.8988Z'
          fill='#F9E8E6'
        />
        <path
          d='M59.3331 40C59.3331 40.53 59.3088 41.0538 59.2694 41.5712C60.0294 41.42 60.7713 41.195 61.485 40.8988C61.5944 40.8538 61.705 40.8144 61.815 40.7719C61.8238 40.5156 61.8325 40.2594 61.8325 40C61.8325 33.225 58.0163 27.5 53.4994 27.5C51.9756 27.5 50.5638 27.9419 49.3325 28.6594V31.1594C50.5644 30.4412 51.9763 30 53.5 30C56.2538 30 59.3331 34.2762 59.3331 40Z'
          fill='#FACBBC'
        />
        <path
          d='M61.4848 40.8988C58.6961 42.0551 55.4667 42.1488 52.4579 40.8988C50.8629 40.2388 49.2061 39.9588 47.5836 40.0095C46.8004 41.7951 45.7767 43.4513 44.5498 44.9345C44.7073 44.8745 44.8642 44.817 45.0204 44.7526C46.9086 43.9713 48.9836 43.9751 50.8636 44.7488C54.1823 46.1232 57.7836 46.3345 61.1923 45.3945C61.5504 43.9113 61.7629 42.3645 61.8154 40.772C61.7048 40.8145 61.5942 40.8532 61.4848 40.8988Z'
          fill='#88D3E1'
        />
        <path
          d='M61.816 40.7712C61.7053 40.8137 61.5947 40.8531 61.486 40.8981C60.7722 41.195 60.0303 41.4194 59.2703 41.5706C59.156 43.0731 58.8816 44.5225 58.4653 45.9006C59.3828 45.8137 60.2941 45.6419 61.1928 45.3937C61.551 43.9112 61.7635 42.3644 61.816 40.7712Z'
          fill='#00ABC0'
        />
        <path
          d='M48.2916 50.417C49.4421 50.417 50.3747 49.4843 50.3747 48.3339C50.3747 47.1834 49.4421 46.2507 48.2916 46.2507C47.1411 46.2507 46.2085 47.1834 46.2085 48.3339C46.2085 49.4843 47.1411 50.417 48.2916 50.417Z'
          fill='#88D3E1'
        />
        <path
          d='M54.0205 52.5C54.8835 52.5 55.583 51.8004 55.583 50.9375C55.583 50.0746 54.8835 49.375 54.0205 49.375C53.1576 49.375 52.458 50.0746 52.458 50.9375C52.458 51.8004 53.1576 52.5 54.0205 52.5Z'
          fill='#88D3E1'
        />
        <path
          d='M45.6875 57.709C46.5504 57.709 47.25 57.0094 47.25 56.1465C47.25 55.2835 46.5504 54.584 45.6875 54.584C44.8246 54.584 44.125 55.2835 44.125 56.1465C44.125 57.0094 44.8246 57.709 45.6875 57.709Z'
          fill='#88D3E1'
        />
        <path
          d='M50.3749 55.6257C50.9503 55.6257 51.4168 55.1593 51.4168 54.5839C51.4168 54.0085 50.9503 53.542 50.3749 53.542C49.7995 53.542 49.333 54.0085 49.333 54.5839C49.333 55.1593 49.7995 55.6257 50.3749 55.6257Z'
          fill='#88D3E1'
        />
        <path
          d='M43.0829 52.5007C43.6583 52.5007 44.1248 52.0343 44.1248 51.4589C44.1248 50.8835 43.6583 50.417 43.0829 50.417C42.5075 50.417 42.041 50.8835 42.041 51.4589C42.041 52.0343 42.5075 52.5007 43.0829 52.5007Z'
          fill='#88D3E1'
        />
        <path
          d='M39.9579 57.7083C40.5333 57.7083 40.9998 57.2418 40.9998 56.6664C40.9998 56.091 40.5333 55.6245 39.9579 55.6245C39.3825 55.6245 38.916 56.091 38.916 56.6664C38.916 57.2418 39.3825 57.7083 39.9579 57.7083Z'
          fill='#88D3E1'
        />
        <path
          d='M53.5 23.3331C52.0369 23.3331 50.6375 23.5981 49.3331 24.0594V15H45.1669V31.6669C45.1669 40.8706 37.7056 48.3337 28.5 48.3337H24.3331C19.7312 48.3337 16 52.0644 16 56.6662V65H20.1669V56.6662C20.1669 54.9012 21.275 53.3975 22.83 52.7919C26.675 60.05 34.2981 65 43.0831 65C55.7425 65 66 53.8037 66 40C66 30.7956 60.4056 23.3331 53.5 23.3331ZM43.0831 60.8337C36.5975 60.8337 30.8725 57.5206 27.5031 52.5H28.5C39.9869 52.5 49.3331 43.1531 49.3331 31.6669V28.6594C50.5644 27.9412 51.9762 27.5 53.5 27.5C58.0169 27.5 61.8331 33.225 61.8331 40C61.8331 51.4869 53.4231 60.8337 43.0831 60.8337Z'
          fill='#F27046'
        />
        <path
          d='M47.6224 49.7475C47.6224 48.5975 48.5568 47.665 49.7061 47.665C49.9074 47.665 50.0986 47.7031 50.2836 47.7556C50.0311 46.8881 49.2393 46.25 48.2918 46.25C47.1424 46.25 46.208 47.1837 46.208 48.3337C46.208 49.2812 46.8461 50.0731 47.7136 50.3263C47.6599 50.1406 47.6224 49.95 47.6224 49.7475Z'
          fill='#00ABC0'
        />
        <path
          d='M53.5186 51.9981C53.518 51.135 54.2186 50.4356 55.0805 50.4356C55.2318 50.4356 55.3761 50.4637 55.5143 50.5037C55.3255 49.8537 54.7324 49.375 54.0205 49.375C53.158 49.375 52.458 50.0744 52.458 50.9375C52.458 51.6494 52.9374 52.2425 53.5874 52.4306C53.5474 52.2925 53.5186 52.1494 53.5186 51.9981Z'
          fill='#00ABC0'
        />
        <path
          d='M45.1858 57.2055C45.1858 56.3424 45.8858 55.643 46.7483 55.643C46.8995 55.643 47.0433 55.6724 47.1814 55.7111C46.992 55.0618 46.3989 54.583 45.687 54.583C44.8245 54.5818 44.1245 55.2811 44.1245 56.1443C44.1245 56.8561 44.6039 57.4493 45.2539 57.6386C45.2139 57.5011 45.1858 57.3568 45.1858 57.2055Z'
          fill='#00ABC0'
        />
        <path
          d='M42.7495 52.1656C42.7495 51.5894 43.2151 51.1231 43.7914 51.1231C43.892 51.1231 43.987 51.1425 44.0801 51.1694C43.9545 50.7363 43.5589 50.4163 43.0839 50.4163C42.5076 50.4163 42.042 50.8825 42.042 51.4588C42.042 51.9325 42.3607 52.3281 42.7945 52.455C42.7676 52.3619 42.7495 52.2669 42.7495 52.1656Z'
          fill='#00ABC0'
        />
        <path
          d='M50.0405 55.2906C50.0405 54.7144 50.5061 54.2481 51.0824 54.2481C51.1836 54.2481 51.2793 54.2675 51.3711 54.2944C51.2455 53.8613 50.8505 53.5413 50.3749 53.5413C49.7993 53.5413 49.333 54.0075 49.333 54.5838C49.333 55.0575 49.6518 55.4531 50.0855 55.58C50.0593 55.4869 50.0405 55.3919 50.0405 55.2906Z'
          fill='#00ABC0'
        />
        <path
          d='M39.6239 57.3731C39.6239 56.7981 40.0901 56.3319 40.6657 56.3319C40.7664 56.3319 40.8614 56.3513 40.9545 56.3781C40.8295 55.9438 40.4339 55.625 39.9589 55.625C39.3832 55.625 38.917 56.0913 38.917 56.6663C38.917 57.1413 39.2357 57.5369 39.6695 57.6625C39.6432 57.5706 39.6239 57.4744 39.6239 57.3731Z'
          fill='#00ABC0'
        />
        <path d='M16 62.5H20.1669V65H16V62.5Z' fill='#D64527' />
        <path d='M45.167 15H49.3332V17.5H45.167V15Z' fill='#D64527' />
      </g>
      <defs>
        <clipPath id='clip0_414_8465'>
          <rect width='50' height='50' fill='white' transform='translate(15.8569 15)' />
        </clipPath>
      </defs>
    </svg>
  )
);
ObstetricsGynaecologyIcon.displayName = 'ObstetricsGynaecologyIcon';

export default ObstetricsGynaecologyIcon;
